import React from 'react';
import { connect } from 'react-redux';
import { getPlatformAccessRequests, updateRequestPlatformAccess, removePlatformAccessRequests} from './ClientsAction'
import ClientAccessRequest from '../../components/ClientAccessRequest'
import { getInvitationCodes, generateInvitationCode, inviteClient } from './InvitationsActions';
import moment from 'moment';

const initialStartDate = moment().subtract(1, "year").format("YYYY-MM-DD");
const initialEndDate = moment().add(1, "day").set("hour", 23).set("minute", 59).set("second", 59).format("YYYY-MM-DD HH:mm:ss");

class ClientAccessRequestContainer extends React.Component {

    constructor(props){
        super(props)
    }

    componentDidMount() {
        let { dispatchGetPlatformAccessRequests, quotes } = this.props;
        dispatchGetPlatformAccessRequests({
            startDate: initialStartDate,
            endDate: initialEndDate
        }, (err, result) => {

        });
    }

    render(){
        const {accessRequests, dispatchGetInvitationCodes, updateAccessRequests, dispatchGetPlatformAccessRequests, dispatchUpdateRequestPlatformAccess, dispatchRemovePlatformAccessRequests} = this.props
        return (
            <ClientAccessRequest 
            initialStartDate={initialStartDate}
            initialEndDate={initialEndDate}
            updateAccessRequests={updateAccessRequests}
            accessRequests={accessRequests}
            dispatchGetPlatformAccessRequests={dispatchGetPlatformAccessRequests}
            dispatchUpdateRequestPlatformAccess={dispatchUpdateRequestPlatformAccess}
            dispatchRemovePlatformAccessRequests={dispatchRemovePlatformAccessRequests}
            dispatchGetInvitationCodes={dispatchGetInvitationCodes}
            
            />
        );
    }
}


const mapStateToProps = (state) => ({
    accessRequests: state.accessRequests,
    updateAccessRequests: state.updateAccessRequests
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchGetPlatformAccessRequests: (parameters, cb) => dispatch(getPlatformAccessRequests(parameters, cb)),
        dispatchUpdateRequestPlatformAccess: (parameters, cb) => dispatch(updateRequestPlatformAccess(parameters, cb)),
        dispatchRemovePlatformAccessRequests: (parameters, cb) => dispatch(removePlatformAccessRequests(parameters, cb)),
        dispatchGetInvitationCodes: () => dispatch(getInvitationCodes())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientAccessRequestContainer);


// WEBPACK FOOTER //
// ./src/containers/Clients/ClientAccessRequestContainer.js